import clsx from 'clsx';
import styles from './TabSwitcher.module.css';

export function TabSwitcher({ items, ariaLabel = 'Tabs' }) {
  return (
    <div className={clsx(styles.tabs)} aria-label={ariaLabel} role="group">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          className={clsx(styles.tab, item.isActive && styles.tabActive)}
          aria-pressed={item.isActive}
          onClick={item.onClick}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
